import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

const GetAgentId = async (uid) => {
  /**
   * input: uid: users id
   * output: user role
   * description: fetches user role
   */

  try {
    const userDoc = await doc(db, "users", uid);
    const userDocSnapshot = await getDoc(userDoc);
    const userDocDetails = userDocSnapshot.data();
    return [userDocDetails.aid, userDocDetails.bid];
  } catch (error) {
    console.log(error);
  }
};

export default GetAgentId;
